<script setup lang="ts">
import type { SliceInterface } from '@voix/types'

const props = defineProps<{
  slice: SliceInterface
}>()

defineSlice({
  fields: {},
  slots: [{ name: 'default', allowedElements: ['Seadust Restaurant List Block'] }],
  name: { label: 'Seadust Restaurant List', group: 'Seadust', layouts: ['Seadust'] },
  templates: [{ label: 'Seadust Restaurant List', fields: [] }],
})

const filter = ref('all')

const slices = computed(() => {
  return props.slice.elements.filter((s) => {
    const field = s.fields?.find((field) => {
      if (field.name === 'type') {
        return field
      }
    })

    if (filter.value === 'all')
      return true
    return field.select === filter.value
  })
})

function setFilter(value: string) {
  filter.value = value
}
</script>

<template>
  <div class="flex flex-col justify-center items-center mt-12">
    <!-- Filters -->
    <div class="flex flex-row flex-wrap space-x-4 justify-center relative px-4 mb-10">
      <div class="w-fit" @click="setFilter('all')">
        <span class="subtitle text-xl uppercase duration-500 ease-in-out cursor-pointer" :class="{ 'text-color-primary': filter === 'all', 'text-[#374151]': filter !== 'all' }">
          All
        </span>
        <div class="h-[2px] w-full bg-color-primary duration-500 ease-in-out" :class="{ 'opacity-100': filter === 'all', 'opacity-0': filter !== 'all' }" />
      </div>

      <div class="w-fit" @click="setFilter('bar')">
        <span class="subtitle text-xl uppercase duration-500 ease-in-out cursor-pointer" :class="{ 'text-color-primary': filter === 'bar', 'text-[#374151]': filter !== 'bar' }">
          Bars
        </span>
        <div class="h-[2px] w-full bg-color-primary duration-500 ease-in-out" :class="{ 'opacity-100': filter === 'bar', 'opacity-0': filter !== 'bar' }" />
      </div>

      <div class="w-fit" @click="setFilter('restaurant')">
        <span class="subtitle text-xl uppercase duration-500 ease-in-out cursor-pointer" :class="{ 'text-color-primary': filter === 'restaurant', 'text-[#374151]': filter !== 'restaurant' }">
          Restaurant
        </span>
        <div class="h-[2px] w-full bg-color-primary duration-500 ease-in-out" :class="{ 'opacity-100': filter === 'restaurant', 'opacity-0': filter !== 'restaurant' }" />
      </div>
    </div>

    <!-- Gallery -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
      <VoixSlice v-for="s in slices" :key="s.id" :slice="s as SliceInterface" />
    </div>
  </div>
</template>
